(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("libs-content-helper", [], factory);
	else if(typeof exports === 'object')
		exports["libs-content-helper"] = factory();
	else
		root["libs-content-helper"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentHelper = undefined;

var _constant = __webpack_require__(1);

/* Public Functions*/

/**
 * Determines if the content type generates scores or not.
 * @param {object} content, must have 'contributes-to-completion' and 'sub-type' fields present.
 * @return {boolean}
 */
function contentGeneratesScore(content) {
  return content['contributes-to-completion'] && _constant.CONSTANTS.TYPES_THAT_GENERATE_SCORE.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content is of 'downloadable' type or not.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isDownloadableContent(content) {
  return _constant.CONSTANTS.DOWNLOADABLE_TYPES.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content is performed by a group only.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isGroupContent(content) {
  return _constant.CONSTANTS.GROUP_CONTENT_TYPES.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content is of 'collaborative' type.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isCollaborativeTask(content) {
  return content['sub-type'] === _constant.CONSTANTS.COLLABORATIVE_TASK_TYPE;
}

/**
 * Determines if the content is of Speaking Productive Skill type.
 * @param {object} content, must have 'sub-type', 'cup-options' field.
 *                                             (a)'submission', contains id key
 *                                             (b) 'id', gives id value
 * @return {boolean}
 */
function isSpeakingProductiveSkill(content) {
  return content['sub-type'] === _constant.CONSTANTS.PRODUCTIVE_SKILL_TYPE && content['cup-options'] && content['cup-options']['submission'] && content['cup-options']['submission']['id'] === 'speak';
}

/**
 * Determines if the content is of Group Productive Skill type.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isGroupProductiveSkill(content) {
  return content['sub-type'] === _constant.CONSTANTS.GROUP_PRODUCTIVE_SKILL_TYPE;
}

/**
 * Determines if the content-type is of test type.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isTestContent(content) {
  return _constant.CONSTANTS.TYPES_THAT_GENERATE_SCORE.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content is available for teacher only
 * @param {object} content, must have 'model.role' field present
 * @return {boolean}
 */
function isTeacherOnlyContent(content) {
  return content && content.model && content.model.role === 'teacher';
}

/**
 * Determines if the content is of submittable type(for further evaluation).
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isSubmittableContent(content) {
  return _constant.CONSTANTS.SUBMITTABLE_TYPES.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content-type requires 'Xapi' to launch.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isXapiContent(content) {
  return _constant.CONSTANTS.XAPI_CONTENT_TYPES.indexOf(content['sub-type']) > -1;
}

/**
 * Determines if the content is of Generic LTI type.
 * @param {object} content, must have 'sub-type' field present.
 * @return {boolean}
 */
function isGenericLtiContent(content) {
  return content['sub-type'] === _constant.CONSTANTS.GENERIC_LTI_TYPE;
}

/**
 * Filter the content types depending on the certain flags.
 * @param {object} content, activity
 * @param {flags} flags, It includes various falgs used for the conditional filtering.
 * flags
 * includeTeacherActivities, include teacher only activities in resultant array, default value = false
 * includeDownloadables, include downloadable activities, default value = false
 * includeNoScoreContent, include non scorable activities, default value = true
 * @return {boolean}
 */
function isContentVisible(content) {
  var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var contentType = content['sub-type'];

  if (_constant.CONSTANTS.ALLOWED_CONTENT_TYPES.indexOf(contentType) === -1) {
    return false;
  }
  if (!flags.inlcudeTeacherOnly && isTeacherOnlyContent(content)) {
    return false;
  }
  if (!flags.includeDownloadables && isDownloadableContent(content)) {
    return false;
  }
  return !(flags.includeNoScoreContent === false && !contentGeneratesScore(content));
}

/**
 * Filter the content types depending on the certain flags.
 * @param {array} listOfContent, A list of activities
 * @param {flags} flags, It includes various falgs used for the conditional filtering.
 * flags
 * includeTeacherActivities, include teacher only activities in resultant array, default value = false
 * includeDownloadables, include downloadable activities, default value = false
 * includeNoScoreContent, include non scorable activities, default value = true
 * @return {array} array of activities filtered based on above params
 */
function filterContentList(listOfContent) {
  var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return listOfContent.filter(function (content) {
    return isContentVisible(content, flags);
  });
}

/**
 * Determines whether to use C1 Result Screen for displaying scores of the content.
 * @param {object} content, must have 'sub-type' and 'containerType' field present
 * @param {string} resultsType, 'results-display' tag value
 * @return {string} type of container
 */
function containerResultScreen(content) {
  if (content['sub-type'] === _constant.CONSTANTS.SCORABLE_TYPE) {
    if (content[_constant.CONSTANTS.SCORABLE_TYPE] && (content[_constant.CONSTANTS.SCORABLE_TYPE]['container'] === 'Channel' || content[_constant.CONSTANTS.SCORABLE_TYPE]['container'] === 'spa-container')) {
      return true;
    }
  }
  return false;
}

var ContentHelper = {
  contentGeneratesScore: contentGeneratesScore,
  isDownloadableContent: isDownloadableContent,
  isGroupContent: isGroupContent,
  isCollaborativeTask: isCollaborativeTask,
  isSpeakingProductiveSkill: isSpeakingProductiveSkill,
  isGroupProductiveSkill: isGroupProductiveSkill,
  isTeacherOnlyContent: isTeacherOnlyContent,
  isSubmittableContent: isSubmittableContent,
  isXapiContent: isXapiContent,
  isTestContent: isTestContent,
  isGenericLtiContent: isGenericLtiContent,
  isContentVisible: isContentVisible,
  filterContentList: filterContentList,
  containerResultScreen: containerResultScreen
};

exports.ContentHelper = ContentHelper;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONSTANTS = {
  SCORABLE_TYPE: 'ext-cup-xapiscoreable',
  NONSCORABLE_TYPE: 'ext-cup-xapi',
  COLLABORATIVE_TASK_TYPE: 'cup-collab-task',
  HTML_TYPE: 'ext-cup-html',
  PRODUCTIVE_SKILL_TYPE: 'cup-pskill',
  GROUP_PRODUCTIVE_SKILL_TYPE: 'cup-pskill-group',
  GENERIC_LTI_TYPE: 'generic-lti',

  AUDIO_TYPE: 'audio',
  VIDEO_TYPE: 'video',
  ZIP_TYPE: 'zip',
  WORD_TYPE: 'word',
  EXCEL_TYPE: 'excel',
  PDF_TYPE: 'pdf',

  GENERIC_XAPI_CONTAINER: 'generic-container',
  SEGMENT_PRIMARY: 'primary',
  SEGMENT_SECONDARY: 'secondary',

  RESULT_TYPE_VALUES: {
    REWARDS: 'rewards',
    DEFAULT: 'default',
    NO_RESULT: 'no_results'
  },
  SCORE_FORMAT_VALUES: {
    MARKS_OUT_OF: 'marks_out_of',
    PERCENTAGE: 'percentage'
  },
  CONTAINER_TYPES: {
    DOWNLOADABLE: 'downloadable',
    COLLAB_TASK: 'collab-task',
    PSKILL: 'pskill',
    XAPI: 'xapi'
  }
};

CONSTANTS.TYPES_THAT_GENERATE_SCORE = [CONSTANTS.SCORABLE_TYPE, CONSTANTS.PRODUCTIVE_SKILL_TYPE, CONSTANTS.GROUP_PRODUCTIVE_SKILL_TYPE, CONSTANTS.GENERIC_LTI_TYPE];

CONSTANTS.ALLOWED_CONTENT_TYPES = [CONSTANTS.SCORABLE_TYPE, CONSTANTS.NONSCORABLE_TYPE, CONSTANTS.COLLABORATIVE_TASK_TYPE, CONSTANTS.HTML_TYPE, CONSTANTS.PRODUCTIVE_SKILL_TYPE, CONSTANTS.GROUP_PRODUCTIVE_SKILL_TYPE, CONSTANTS.AUDIO_TYPE, CONSTANTS.VIDEO_TYPE, CONSTANTS.ZIP_TYPE, CONSTANTS.WORD_TYPE, CONSTANTS.EXCEL_TYPE, CONSTANTS.PDF_TYPE, CONSTANTS.GENERIC_LTI_TYPE];

CONSTANTS.DOWNLOADABLE_TYPES = [CONSTANTS.AUDIO_TYPE, CONSTANTS.VIDEO_TYPE, CONSTANTS.ZIP_TYPE, CONSTANTS.WORD_TYPE, CONSTANTS.EXCEL_TYPE, CONSTANTS.PDF_TYPE];

CONSTANTS.SUBMITTABLE_TYPES = [CONSTANTS.PRODUCTIVE_SKILL_TYPE, CONSTANTS.GROUP_PRODUCTIVE_SKILL_TYPE];

CONSTANTS.GROUP_CONTENT_TYPES = [CONSTANTS.GROUP_PRODUCTIVE_SKILL_TYPE, CONSTANTS.COLLABORATIVE_TASK_TYPE];

CONSTANTS.XAPI_CONTENT_TYPES = [CONSTANTS.SCORABLE_TYPE, CONSTANTS.NONSCORABLE_TYPE, CONSTANTS.HTML_TYPE];

exports.CONSTANTS = CONSTANTS;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EsTranslations = exports.EnTranslations = exports.ProductContentHelper = exports.ContentHelper = undefined;

var _contentHelper = __webpack_require__(0);

var _productContentHelper = __webpack_require__(3);

var _en = __webpack_require__(4);

var _en2 = _interopRequireDefault(_en);

var _es = __webpack_require__(5);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ContentHelper = _contentHelper.ContentHelper;
exports.ProductContentHelper = _productContentHelper.ProductContentHelper;
exports.EnTranslations = _en2.default;
exports.EsTranslations = _es2.default;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductContentHelper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _contentHelper = __webpack_require__(0);

var _constant = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PATH = './node_modules/libs-content-helper/dist/assets/img/';

/* Constants for Icon Maps */

var GREY_STAR = {
  iconClass: 'nemo-font nemo-progress-above lch-star-not-started'
};

var LINED_STAR = {
  iconClass: 'nemo-font nemo-progress-below lch-star-belowthreshold'
};

var GOLD_STAR = {
  iconClass: 'nemo-font nemo-progress-above lch-star-abovethreshold'
};

var HOLLOW_STAR = {
  iconClass: 'fa fa-star-o lch-star-evaluation-pending'
};

var EMPTY_MEDAL = {
  iconClass: 'lch-medal-not-started',
  imagePath: PATH + 'empty-medal.svg'
};

var IN_PROGRESS_BLUE = {
  iconClass: 'lch-in-progress-icon',
  imagePath: PATH + 'inprogress_blue.png'
};

var IN_PROGRESS_PURPLE = {
  iconClass: 'lch-in-progress-icon',
  imagePath: PATH + 'inprogress_purple.png'
};

var BRONZE_MEDAL = {
  iconClass: 'lch-medal-belowthreshold',
  imagePath: PATH + 'below-medal.svg'
};

var GOLD_MEDAL = {
  iconClass: 'lch-medal-abovethreshold',
  imagePath: PATH + 'above-medal.svg'
};

var GREEN_TICK_ICON = {
  iconClass: 'nemo-font nemo-tick lch-green-tick'
};

/* Constants for component/toplevel Icon Maps */
var TOP_HOLLOW_STAR = {
  iconClass: 'fa fa-star-o lch-top-star-evaluation-pending'
};

var TOP_LINED_STAR = {
  iconClass: 'nemo-font nemo-progress-below lch-top-star-belowthreshold'
};

var TOP_GOLD_STAR = {
  iconClass: 'nemo-font nemo-progress-above lch-top-star-abovethreshold'
};

var TOP_EMPTY_MEDAL = {
  iconClass: 'lch-top-medal-not-started',
  imagePath: PATH + 'empty-medal.svg'
};

var TOP_IN_PROGRESS_BLUE = {
  iconClass: 'lch-top-in-progress-icon',
  imagePath: PATH + 'inprogress_blue.png'
};

var TOP_IN_PROGRESS_PURPLE = {
  iconClass: 'lch-top-in-progress-icon',
  imagePath: PATH + 'inprogress_purple.png'
};

var TOP_GOLD_MEDAL = {
  iconClass: 'lch-top-medal-abovethreshold',
  imagePath: PATH + 'above-medal.svg'
};

var TOP_BRONZE_MEDAL = {
  iconClass: 'lch-top-medal-belowthreshold',
  imagePath: PATH + 'below-medal.svg'
};

/* ICON_MAP, it consists of the classes, icon translations and image path if any for the category of icon. */
var ICON_MAP = {
  REWARDS: {
    NOT_STARTED: _extends({}, EMPTY_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_NOT_STARTED'
    }),
    IN_PROGRESS: {
      primary: _extends({}, IN_PROGRESS_BLUE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      }),
      secondary: _extends({}, IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      }),
      adult: _extends({}, IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      })
    },
    COMPLETED_BELOW_THRESHOLD: _extends({}, BRONZE_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_BELOW_THRESHOLD'
    }),
    COMPLETED_ABOVE_THRESHOLD: _extends({}, GOLD_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_ABOVE_THRESHOLD'
    }),
    VIEWED: _extends({}, GREEN_TICK_ICON, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_VIEWED'
    }),
    EVALUATION_PENDING: _extends({}, EMPTY_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
    }),
    NOT_STARTED_NON_SCOREABLE: {}
  },
  DEFAULT: {
    NOT_STARTED: _extends({}, GREY_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_NOT_STARTED'
    }),
    IN_PROGRESS: {
      primary: _extends({}, IN_PROGRESS_BLUE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      }),
      secondary: _extends({}, IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      }),
      adult: _extends({}, IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
      })
    },
    COMPLETED_BELOW_THRESHOLD: _extends({}, LINED_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_BELOW_THRESHOLD'
    }),
    COMPLETED_ABOVE_THRESHOLD: _extends({}, GOLD_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_ABOVE_THRESHOLD'
    }),
    VIEWED: _extends({}, GREEN_TICK_ICON, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_VIEWED'
    }),
    EVALUATION_PENDING: _extends({}, HOLLOW_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
    }),
    NOT_STARTED_NON_SCOREABLE: {}
  }
};

/* NLP_ICON_MAP, it consists of the classes, icon translations and image path for NLP only.*/
var NLP_ICON_MAP = {
  REWARDS: {
    NOT_STARTED_SCOREABLE: {
      LEFT_ICON: {},
      RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
      })
    },
    NOT_STARTED_NON_SCOREABLE: {
      LEFT_ICON: {},
      RIGHT_ICON: {}
    },
    IN_PROGRESS_SCOREABLE: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      }
    },
    IN_PROGRESS_NON_SCOREABLE: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      }
    },
    COMPLETED_ABOVE_THRESHOLD_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      }),
      RIGHT_ICON: _extends({}, GOLD_MEDAL, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_ABOVE_THRESHOLD'
      })
    },
    COMPLETED_BELOW_THRESHOLD_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      }),
      RIGHT_ICON: _extends({}, BRONZE_MEDAL, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_BELOW_THRESHOLD'
      })
    },
    COMPLETED_NON_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      })
    },
    EVALUATION_PENDING: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, EMPTY_MEDAL, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      }
    }
  },
  DEFAULT: {
    NOT_STARTED_SCOREABLE: {
      LEFT_ICON: {},
      RIGHT_ICON: _extends({}, GREY_STAR, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_NOT_STARTED'
      })
    },
    NOT_STARTED_NON_SCOREABLE: {
      LEFT_ICON: {},
      RIGHT_ICON: {}
    },
    IN_PROGRESS_SCOREABLE: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, GREY_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, GREY_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, GREY_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_GAIN_REWARD'
        })
      }
    },
    IN_PROGRESS_NON_SCOREABLE: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: {}
      }
    },
    COMPLETED_ABOVE_THRESHOLD_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      }),
      RIGHT_ICON: _extends({}, GOLD_STAR, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_ABOVE_THRESHOLD'
      })
    },
    COMPLETED_BELOW_THRESHOLD_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      }),
      RIGHT_ICON: _extends({}, LINED_STAR, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_BELOW_THRESHOLD'
      })
    },
    COMPLETED_NON_SCOREABLE: {
      LEFT_ICON: _extends({}, GREEN_TICK_ICON, {
        description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_COMPLETED'
      })
    },
    EVALUATION_PENDING: {
      primary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_BLUE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, HOLLOW_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      },
      secondary: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, HOLLOW_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      },
      adult: {
        LEFT_ICON: _extends({}, IN_PROGRESS_PURPLE, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_IN_PROGRESS'
        }),
        RIGHT_ICON: _extends({}, HOLLOW_STAR, {
          description: '__CONTENT_HELPER__.SCREEN_READER.STATUS_EVALUATION_PENDING'
        })
      }
    }
  }
};

/* TOP_ICON_MAP, it consists of the classes, icon translations and image path if any
  for the component/top level icons. */
var TOP_ICON_MAP = {
  REWARDS: {
    IN_PROGRESS: {
      primary: _extends({}, TOP_IN_PROGRESS_BLUE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      }),
      secondary: _extends({}, TOP_IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      }),
      adult: _extends({}, TOP_IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      })
    },
    COMPLETED_ABOVE_THRESHOLD: _extends({}, TOP_GOLD_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_ABOVE_THRESHOLD'
    }),
    COMPLETED_BELOW_THRESHOLD: _extends({}, TOP_BRONZE_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_BELOW_THRESHOLD'
    }),
    EVALUATION_PENDING: _extends({}, TOP_EMPTY_MEDAL, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_EVALUATION_PENDING'
    })
  },
  DEFAULT: {
    IN_PROGRESS: {
      primary: _extends({}, TOP_IN_PROGRESS_BLUE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      }),
      secondary: _extends({}, TOP_IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      }),
      adult: _extends({}, TOP_IN_PROGRESS_PURPLE, {
        description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_IN_PROGRESS'
      })
    },
    COMPLETED_BELOW_THRESHOLD: _extends({}, TOP_LINED_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_BELOW_THRESHOLD'
    }),
    COMPLETED_ABOVE_THRESHOLD: _extends({}, TOP_GOLD_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_ABOVE_THRESHOLD'
    }),
    EVALUATION_PENDING: _extends({}, TOP_HOLLOW_STAR, {
      description: '__CONTENT_HELPER__.SCREEN_READER.TOP_STATUS_EVALUATION_PENDING'
    })
  }
};

/**
 * @return {object}, folder level analytics object
 */
function getFolderLevelAnalyticsObject() {
  return {
    itemsCount: {
      total: 0,
      testItems: 0,
      nonTestItems: 0,
      notStarted: 0,
      inComplete: 0,
      completedAndContributeCompletion: 0,
      completedWithSuccessAndContributeCompletion: 0,
      completedWithSuccessTestAndContributeCompletion: 0,
      completedMixedTestAndContributeCompletion: 0,
      testItemsContribCompletion: 0,
      contributeCompletion: 0,
      completed: 0,
      completedWithSuccess: 0,
      completedWithSuccessTest: 0,
      completedOnceTestAndContributeCompletion: 0
    },
    aggregateGrade: 0,
    aggregateGradeBest: 0,
    aggregateGradeFirst: 0,
    completedGradedItems: 0,
    grade: 0,
    gradeBest: 0,
    gradeFirst: 0,
    ts: 0,
    lastAccessed: 0,
    firstAccessed: 0
  };
}

/**
 * @param {object} folderAnalytics
 * @param {object} itemData
 * @return
 */
function updateFolderAnalyticsForItem(folderAnalytics, itemData) {
  var itemAnalytics = itemData.__analytics;
  var itemCtc = itemData['contributes-to-completion'];
  var isTestItem = _contentHelper.ContentHelper.isTestContent(itemData);

  folderAnalytics.itemsCount.total++;
  if (isTestItem) {
    folderAnalytics.itemsCount.testItems++;
  } else {
    folderAnalytics.itemsCount.nonTestItems++;
  }

  if (itemCtc) {
    folderAnalytics.itemsCount.contributeCompletion++;

    if (isTestItem) {
      folderAnalytics.itemsCount.testItemsContribCompletion++;
    }
  }

  if (!itemAnalytics) {
    return;
  }

  folderAnalytics.ts += itemAnalytics.timespent || 0;

  if (folderAnalytics.lastAccessed < itemAnalytics.lastAccessed) {
    folderAnalytics.lastAccessed = itemAnalytics.lastAccessed;
  }

  if (!folderAnalytics.firstAccessed || itemAnalytics.firstAccessed && folderAnalytics.firstAccessed > itemAnalytics.firstAccessed) {
    folderAnalytics.firstAccessed = itemAnalytics.firstAccessed;
  }

  if (itemAnalytics.completedOnce) {
    folderAnalytics.itemsCount.completed++;

    if (itemCtc) {
      folderAnalytics.itemsCount.completedAndContributeCompletion++;

      if (isTestItem) {
        folderAnalytics.itemsCount.completedOnceTestAndContributeCompletion++;
      }

      if (itemAnalytics.completedOnceWithSuccess) {
        folderAnalytics.itemsCount.completedWithSuccess++;
        folderAnalytics.itemsCount.completedWithSuccessAndContributeCompletion++;

        if (isTestItem) {
          folderAnalytics.itemsCount.completedWithSuccessTest++;
          folderAnalytics.itemsCount.completedWithSuccessTestAndContributeCompletion++;
        }
      }

      if (itemAnalytics.lastResult) {
        folderAnalytics.completedGradedItems++;
        if (itemAnalytics.lastResult.scaledScore) {
          folderAnalytics.aggregateGrade += itemAnalytics.lastResult.scaledScore;
        }
      }

      if (itemAnalytics.evaluationOverride) {
        folderAnalytics.aggregateGradeBest += itemAnalytics.evaluationOverride[0].review.result;
        folderAnalytics.aggregateGradeFirst += itemAnalytics.evaluationOverride[0].review.result;
      } else {
        if (itemAnalytics.bestResult && itemAnalytics.bestResult.scaledScore) {
          folderAnalytics.aggregateGradeBest += itemAnalytics.bestResult.scaledScore;
        }
        if (itemAnalytics.firstResult && itemAnalytics.firstResult.scaledScore) {
          folderAnalytics.aggregateGradeFirst += itemAnalytics.firstResult.scaledScore;
        }
      }
    } else {
      // Item with ctc false
      if (itemAnalytics.completedOnceWithSuccess) {
        folderAnalytics.itemsCount.completedWithSuccess++;

        if (isTestItem) {
          folderAnalytics.itemsCount.completedWithSuccessTest++;
        }
      }
    }
  } else if (itemAnalytics.status) {
    // Incomplete item
    if (itemAnalytics.status === 'not_started') {
      folderAnalytics.itemsCount.notStarted++;
    } else if (itemAnalytics.status === 'in_complete') {
      folderAnalytics.itemsCount.inComplete++;
    }
  }
}

/**
 * @param {object} accumulator
 * @param {object} obj
 */
function accumulateAnalytics(accumulator, obj) {
  for (var key in accumulator) {
    if (_typeof(accumulator[key]) === 'object' && obj && obj[key]) {
      accumulateAnalytics(accumulator[key], obj[key]);
      continue;
    }

    if (!obj || !obj[key]) {
      continue;
    }

    if (key === 'lastAccessed') {
      if (accumulator.lastAccessed < obj.lastAccessed) {
        accumulator[key] = obj[key];
      }
    } else if (key === 'firstAccessed') {
      if (!accumulator.firstAccessed || obj.firstAccessed && accumulator.firstAccessed > obj.firstAccessed) {
        accumulator[key] = obj[key];
      }
    } else {
      accumulator[key] += obj[key];
    }
  }
}

/**
 * @param {object} analytics
 */
function processAccumulatedAnalytics(analytics) {
  if (analytics && analytics.completedGradedItems > 0) {
    analytics.grade = analytics.aggregateGrade * 100 / analytics.completedGradedItems;
    analytics.gradeBest = analytics.aggregateGradeBest * 100 / analytics.completedGradedItems;
    analytics.gradeFirst = analytics.aggregateGradeFirst * 100 / analytics.completedGradedItems;
  }
}

/**
 * @param {object} folderAnalyticsObject
 */
function extractSelectiveAnalytics(folderAnalyticsObject) {
  // Remove unnecessary analytics
  delete folderAnalyticsObject.aggregateGrade;
  delete folderAnalyticsObject.aggregateGradeBest;
  delete folderAnalyticsObject.aggregateGradeFirst;
  delete folderAnalyticsObject.grade;
  delete folderAnalyticsObject.gradeFirst;
  delete folderAnalyticsObject.firstAccessed;
  delete folderAnalyticsObject.itemsCount.testItems;
  delete folderAnalyticsObject.itemsCount.completedGradedItems;
  delete folderAnalyticsObject.itemsCount.inComplete;
  delete folderAnalyticsObject.itemsCount.nonTestItems;
  delete folderAnalyticsObject.itemsCount.completedWithSuccessTest;

  // Map the analytics keys to P3 analytics' keys
  folderAnalyticsObject.itemsCount.all = folderAnalyticsObject.itemsCount.completed;
  delete folderAnalyticsObject.itemsCount.completed;

  folderAnalyticsObject.itemsCount.allWContrib = folderAnalyticsObject.itemsCount.completedAndContributeCompletion;
  delete folderAnalyticsObject.itemsCount.completedAndContributeCompletion;

  folderAnalyticsObject.itemsCount.success = folderAnalyticsObject.itemsCount.completedWithSuccess;
  delete folderAnalyticsObject.itemsCount.completedWithSuccess;

  folderAnalyticsObject.itemsCount.successTestWContrib = folderAnalyticsObject.itemsCount.completedWithSuccessTestAndContributeCompletion;
  delete folderAnalyticsObject.itemsCount.completedWithSuccessTestAndContributeCompletion;

  folderAnalyticsObject.itemsCount.successWContrib = folderAnalyticsObject.itemsCount.completedWithSuccessAndContributeCompletion;
  delete folderAnalyticsObject.itemsCount.completedWithSuccessAndContributeCompletion;

  folderAnalyticsObject.itemsCount.testWContrib = folderAnalyticsObject.itemsCount.completedOnceTestAndContributeCompletion;
  delete folderAnalyticsObject.itemsCount.completedOnceTestAndContributeCompletion;

  delete folderAnalyticsObject.itemsCount.completedMixedTestAndContributeCompletion;
}

/**
 * Get ProductToc Folder Depth
 * @param {array} items
 */
function getTocFolderDepth(items) {
  if (!items || items[0] && items[0]['item-type'] !== 'folder') {
    return 0;
  }

  return 1 + getTocFolderDepth(items[0] && items[0].items);
}

/**
 * Delete unwanted keys from the object
 * @param {object} object
 * @param {array=[]} exceptionKeys
 */
function deleteAllKeysFromObject(object) {
  var exceptionKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var key in object) {
    if (exceptionKeys.indexOf(key) === -1) {
      delete object[key];
    }
  }
}

/**
 * Create map for item code selected in the product
 * @param {object} productColumn
 * @returns {object}
 */
function buildSelectedActivitiesMap(productColumn) {
  var anyActivitiesSelected = productColumn.data && typeof productColumn.data.noOfSelectedItems !== 'undefined';
  var gradeSelectedActivities = {};

  productColumn.items && productColumn.items.forEach(function (item) {
    if (item.type === 'product') {
      // As the whole product is selected, we need to use all the activities for grade calculations
      anyActivitiesSelected = false;
    } else {
      gradeSelectedActivities[item['item-code']] = true;
      anyActivitiesSelected = true;
    }
  });

  return { anyActivitiesSelected: anyActivitiesSelected, gradeSelectedActivities: gradeSelectedActivities };
}

/**
 * Check if the item is selected
 * @param {string} itemCode
 * @param {object} gradeSelectedActivities
 * @returns {boolean}
 */
function isItemSelected(itemCode, gradeSelectedActivities) {
  var itemCodeParts = itemCode.split('/');
  var itemCodeAcc = '';
  var activityIncluded = false;

  if (Object.keys(gradeSelectedActivities).length > 0) {
    // If all activities are excluded, skip this loop
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = itemCodeParts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var part = _step.value;

        itemCodeAcc += (itemCodeAcc ? '/' : '') + part;
        if (gradeSelectedActivities[itemCodeAcc]) {
          activityIncluded = true;
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return activityIncluded;
}

var ProductContentHelper = exports.ProductContentHelper = function () {

  /**  ProductContentHelper CONSTRUCTOR FUNCTION
   *   @constructor
   *   @param {Object} bundleProduct - This needs bundle product to initialize.
   *                                   It contains all the information about bundle.
   *                                   Here we will initialize:   (a) segment
   *                                                              (b) results-display
   *                                                              (c) score-format
   *   @param {boolean} isTestTypeComponent - Denotes if the product is of test type
   *   @param {number} targetScore - targetScore is used as the threshold to determine
   *                                 full/half stars OR gold/bronze medals. This
   *                                 overrides the product level thresholdand is set
   *                                 by admin by associating a grading scale to class.
   */

  function ProductContentHelper(bundleProduct) {
    var isTestTypeComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var targetScore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, ProductContentHelper);

    if (bundleProduct) {
      if (bundleProduct.segment) {
        /** Gives information about the segment of product. */
        this._segment = bundleProduct.segment.segment;
      }
      if (bundleProduct['results-display']) {
        /** Gives information about the results-display and score-format of product to display the icons and
         *  score of specific type. */
        this._resultsType = bundleProduct['results-display'].type;
        this._scoreFormat = bundleProduct['results-display']['score-format'];
        this._hideNonStartedItems = bundleProduct['results-display']['hide-non-started-items'];
      }
    }
    this._isTestTypeComponent = isTestTypeComponent;
    this.targetScore = targetScore;
  }

  /**
   * Function which calculates the scores and returns it in a specific format based on:
   * 'content' and 'scoreFormat' tag.
   * @param {Object} content, it must have 'sub-type', 'contributes-to completion' and analytics.
   * @return {Object} scores/state and their translations.
   */


  _createClass(ProductContentHelper, [{
    key: 'getFormattedScore',
    value: function getFormattedScore(content) {
      if (content && content.__analytics) {
        var analytics = content.__analytics;

        if (_contentHelper.ContentHelper.contentGeneratesScore(content)) {
          var scoresObj = {
            firstScore: {
              val: '-',
              description: '__CONTENT_HELPER__.SCORES.FIRST_SCORE'
            },
            bestScore: {
              val: '-',
              description: '__CONTENT_HELPER__.SCORES.BEST_SCORE'
            },
            attempts: {
              val: analytics.submitCount === 0 ? '-' : analytics.submitCount,
              description: '__CONTENT_HELPER__.SCORES.ATTEMPTS'
            }
          };

          if (analytics.evaluationOverride) {

            scoresObj.teacherScore = {
              val: '-',
              description: '__CONTENT_HELPER__.SCORES.TEACHER_SCORE'
            };

            var teacherScore = analytics.evaluationOverride[0].review;

            if (this._scoreFormat === _constant.CONSTANTS.SCORE_FORMAT_VALUES.MARKS_OUT_OF) {
              scoresObj.teacherScore.val = '<strong>' + Math.round(teacherScore.raw / 10) + '</strong>/10';
            } else {
              scoresObj.teacherScore.val = teacherScore.raw + '%';
            }
          }

          if (analytics.bestResult && (analytics.bestResult.scaledScore || analytics.bestResult.scaledScore === 0)) {
            if (this._scoreFormat === _constant.CONSTANTS.SCORE_FORMAT_VALUES.MARKS_OUT_OF && (analytics.bestResult.raw || analytics.bestResult.raw === 0)) {
              if (_contentHelper.ContentHelper.isSubmittableContent(content)) {
                scoresObj.firstScore.val = '<strong>' + Math.round(analytics.firstResult.raw / 10) + '</strong>/10';
                scoresObj.bestScore.val = '<strong>' + Math.round(analytics.bestResult.raw / 10) + '</strong>/10';
              } else {
                scoresObj.firstScore.val = '<strong>' + analytics.firstResult.raw + '</strong>/' + analytics.firstResult.max;
                scoresObj.bestScore.val = '<strong>' + analytics.bestResult.raw + '</strong>/' + analytics.bestResult.max;
              }
            } else {
              scoresObj.firstScore.val = Math.round(analytics.firstResult.scaledScore * 100) + '%';
              scoresObj.bestScore.val = Math.round(analytics.bestResult.scaledScore * 100) + '%';
            }
          }
          return scoresObj;
        } else if (analytics.completedOnce) {
          return {
            state: {
              val: 'VIEWED',
              description: '__CONTENT_HELPER__.SCORES.VIEWED'
            }
          };
        }
        return {
          state: {
            val: 'NOT_VIEWED',
            description: ''
          }
        };
      }
      return {};
    }

    /**
    * This method maps an appropriate icon for the current status of the content based on its type and analytics.
    * It incorporates Rewards tag and Segment of Component to choose an appropriate icon and other dependencies,
      like translations as per business rules.
    * @param {Object} content, it must have 'sub-type' and 'contributes-to completion' for its processing.
    * @return {Object} icon and their translations.
    */

  }, {
    key: 'getStatusIconForContent',
    value: function getStatusIconForContent(content) {
      if (this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.NO_RESULT) {
        return undefined;
      }

      var iconMapType = this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.REWARDS ? ICON_MAP.REWARDS : ICON_MAP.DEFAULT;

      if (content && content.__analytics) {
        var analytics = content.__analytics;

        if (_contentHelper.ContentHelper.contentGeneratesScore(content)) {
          if (analytics.completedOnceWithSuccess) {
            return iconMapType.COMPLETED_ABOVE_THRESHOLD;
          } else if (analytics.completedOnce) {
            return iconMapType.COMPLETED_BELOW_THRESHOLD;
          } else if (analytics.submittedOnce) {
            return iconMapType.EVALUATION_PENDING;
          } else if (analytics.status !== 'not_started') {
            if (this._segment && iconMapType.IN_PROGRESS[this._segment]) {
              return iconMapType.IN_PROGRESS[this._segment];
            }
            return iconMapType.IN_PROGRESS.adult;
          }
          return iconMapType.NOT_STARTED;
        }
        if (analytics.status === 'not_started') {
          return ICON_MAP.NOT_STARTED_NON_SCOREABLE;
        } else if (!analytics.completedOnce) {
          if (this._segment && iconMapType.IN_PROGRESS[this._segment]) {
            return iconMapType.IN_PROGRESS[this._segment];
          }
          return iconMapType.IN_PROGRESS.adult;
        }
        return iconMapType.VIEWED;
      }
      if (_contentHelper.ContentHelper.contentGeneratesScore(content)) {
        return iconMapType.NOT_STARTED_SCOREABLE;
      }
      return iconMapType.NOT_STARTED_NON_SCOREABLE;
    }

    /**
    * This method maps an appropriate icon for the current status of the content based on its
    * type and analytics NLP(toc page).
    * It incorporates Rewards tag and Segment of Component to choose an appropriate
    * icon and other dependencies like translations, as per business rules.
    * @param {Object} content, it must have 'sub-type' and 'contributes-to completion' for its processing.
    * @return {Object} icons and their translations.
    */

  }, {
    key: 'getActivityIconForNLP',
    value: function getActivityIconForNLP(content) {
      var iconMapType = this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.REWARDS ? NLP_ICON_MAP.REWARDS : NLP_ICON_MAP.DEFAULT;

      if (content && content.__analytics) {
        var analytics = content.__analytics;

        if (_contentHelper.ContentHelper.contentGeneratesScore(content)) {
          if (analytics.completedOnceWithSuccess) {
            return iconMapType.COMPLETED_ABOVE_THRESHOLD_SCOREABLE;
          } else if (analytics.completedOnce) {
            return iconMapType.COMPLETED_BELOW_THRESHOLD_SCOREABLE;
          } else if (analytics.submittedOnce) {
            if (this._segment && iconMapType.EVALUATION_PENDING[this._segment]) {
              return iconMapType.EVALUATION_PENDING[this._segment];
            }
            return iconMapType.EVALUATION_PENDING.adult;
          } else if (analytics.status !== 'not_started') {
            if (this._segment && iconMapType.IN_PROGRESS_SCOREABLE[this._segment]) {
              return iconMapType.IN_PROGRESS_SCOREABLE[this._segment];
            }
            return iconMapType.IN_PROGRESS_SCOREABLE.adult;
          }
          return iconMapType.NOT_STARTED_SCOREABLE;
        }
        if (analytics.completedOnce) {
          return iconMapType.COMPLETED_NON_SCOREABLE;
        } else if (analytics.status !== 'not_started') {
          if (this._segment && iconMapType.IN_PROGRESS_NON_SCOREABLE[this._segment]) {
            return iconMapType.IN_PROGRESS_NON_SCOREABLE[this._segment];
          }
          return iconMapType.IN_PROGRESS_NON_SCOREABLE.adult;
        }
        return iconMapType.NOT_STARTED_NON_SCOREABLE;
      }
      if (_contentHelper.ContentHelper.contentGeneratesScore(content)) {
        return iconMapType.NOT_STARTED_SCOREABLE;
      }
      return iconMapType.NOT_STARTED_NON_SCOREABLE;
    }

    /**
    * This method maps an appropriate icon for the making template, it calculates icon for all the submissions.
    * It incorporates Rewards tag to choose an appropriate icon and other dependencies like
    * translations as per business rules.
    * @param {Object} content, it must have 'pass-score' for its processing.
    * @param {Object} evaluationItem, it must have 'gradingStatus'.
    * @return {Object} icons and their translations.
    */

  }, {
    key: 'getStatusIconForMarkingContent',
    value: function getStatusIconForMarkingContent(content, evaluationItem) {
      if (this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.NO_RESULT) {
        return undefined;
      }

      if (content && evaluationItem) {
        var iconMapType = this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.REWARDS ? ICON_MAP.REWARDS : ICON_MAP.DEFAULT;

        if (evaluationItem['gradingStatus'] !== 'evaluated') {
          return iconMapType.EVALUATION_PENDING;
        } else if (evaluationItem['review'].result >= (this.targetScore ? this.targetScore : content['pass-score'])) {
          return iconMapType.COMPLETED_ABOVE_THRESHOLD;
        }
        return iconMapType.COMPLETED_BELOW_THRESHOLD;
      }
      return {};
    }

    /**
     * Determines the icons based on 'results-display' and 'segment' tag as required by App/view for component/top level.
     * @param none
     * @return {object} icon map, set of icons.
     */

  }, {
    key: 'getTopLevelIconMap',
    value: function getTopLevelIconMap() {
      var iconMapType = this._resultsType === _constant.CONSTANTS.RESULT_TYPE_VALUES.REWARDS ? TOP_ICON_MAP.REWARDS : TOP_ICON_MAP.DEFAULT;

      return this._segment && iconMapType.IN_PROGRESS[this._segment] ? _extends({}, iconMapType, { IN_PROGRESS: _extends({}, iconMapType.IN_PROGRESS[this._segment]) }) : _extends({}, iconMapType, { IN_PROGRESS: _extends({}, iconMapType.IN_PROGRESS.adult) });
    }

    /**
     * This method changes the analytics according to the new targetScore set by admin
     * and teacherOverrideScore set by teacher
     * @param {object} itemData
     * @param {object} [itemAnalytics]
     * @return
     */

  }, {
    key: 'updateAnalyticsAsPerClassCustomisations',
    value: function updateAnalyticsAsPerClassCustomisations(itemData) {
      var itemAnalytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;


      var isItemAnalayticsPresent = !!itemAnalytics;

      if (!itemAnalytics) {
        itemAnalytics = itemData.__analytics;
      }

      if (itemData.hasOwnProperty('pass-score') && itemData['pass-score'] === this.targetScore) {
        delete this.targetScore;
      }

      if (!this.targetScore && !(itemAnalytics && itemAnalytics.evaluationOverride)) {
        return;
      }

      if (!isItemAnalayticsPresent && this.targetScore) {
        itemData['pass-score'] = this.targetScore;
      }

      if (itemAnalytics && itemAnalytics.evaluationOverride) {
        delete itemAnalytics.completedOnceWithSuccessDate;
        delete itemAnalytics.completedOnceWithSuccessResult;
        itemAnalytics.completedOnce = true;
        if (this.targetScore) {
          itemAnalytics.completedOnceWithSuccess = this.targetScore <= itemAnalytics.evaluationOverride[0].review.result;
        } else {
          itemAnalytics.completedOnceWithSuccess = itemData['pass-score'] <= itemAnalytics.evaluationOverride[0].review.result;
        }
      } else if (itemAnalytics && itemAnalytics.completedOnce && itemAnalytics.bestResult && itemAnalytics.bestResult.scaledScore) {
        delete itemAnalytics.completedOnceWithSuccessDate;
        delete itemAnalytics.completedOnceWithSuccessResult;
        itemAnalytics.completedOnceWithSuccess = this.targetScore <= itemAnalytics.bestResult.scaledScore;
      }
    }

    /**
     * Builds folder-level customised analytics object on the product toc
     * - Folder-level means product + unit + lesson level
     * - Also adds scoreObj and iconObj at the activity level
     * - Also marks the items/folders hidden flags
     * @param {object} productToc, product data with items and analytics
     * @param {object} flags, It includes various falgs used for the conditional filtering.
     * flags
     * isTeacherView, if the role is teacher
     * filteredUnits, the array of units for which the units are selected
     * contentFlags, the items to be filtered from the toc
     *  - includeTeacherActivities, include teacher only activities in resultant array, default value = false
     *  - includeDownloadables, include downloadable activities, default value = false
     *  - includeNoScoreContent, include non scorable activities, default value = true
     * transformToP3, flags for transforming to P3
     *  - deleteItems, whether to delete items or not
     * @param {object} productColumn, gradebook column corresponding to the product
     * @return {object} updated product toc
     */

  }, {
    key: 'buildCustomisedAnalytics',
    value: function buildCustomisedAnalytics(productToc) {
      var _this = this;

      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var productColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


      // For painting donut of test OR non-adult components, assume completed as completedWithSuccess
      var useCompletedAsCompletedWithSuccess = this._segment !== 'adult' || this._isTestTypeComponent;
      var addMixedCompletion = function addMixedCompletion(itemsCount) {
        if (useCompletedAsCompletedWithSuccess) {
          itemsCount.completedMixedTestAndContributeCompletion = itemsCount.completedOnceTestAndContributeCompletion;
        } else {
          itemsCount.completedMixedTestAndContributeCompletion = itemsCount.completedWithSuccessTestAndContributeCompletion;
        }
      };

      var hideNonStartedItems = !flags.isTeacherView && this._hideNonStartedItems;
      var isHidden = function isHidden(analytics, productLevel) {
        return hideNonStartedItems && (productLevel || !_this._isTestTypeComponent) && analytics.itemsCount.total === analytics.itemsCount.notStarted;
      };

      var _buildSelectedActivit = buildSelectedActivitiesMap(productColumn),
          anyActivitiesSelected = _buildSelectedActivit.anyActivitiesSelected,
          gradeSelectedActivities = _buildSelectedActivit.gradeSelectedActivities;

      productToc.hasCustomisation = anyActivitiesSelected || productColumn && productColumn.weightage === '0';

      var selectedUnits = flags.filteredUnits || [];
      var tocFolderDepth = getTocFolderDepth(productToc.items);

      var processItems = function processItems(items, existingDefaultAnalytics) {
        // Create default analytics if they don't exist OR the units filter is applied
        var defaultAnalytics = !selectedUnits.length && existingDefaultAnalytics || getFolderLevelAnalyticsObject();
        // If no activity selection is done, use the default analytics
        var customisedAnalytics = anyActivitiesSelected ? getFolderLevelAnalyticsObject() : defaultAnalytics;

        items.forEach(function (item) {

          if (selectedUnits.length > 0) {
            if (selectedUnits.indexOf(item['item-code'].split('/')[0]) === -1) {
              // If the unit is not selected, return
              return;
            }
          }

          // Processing folders
          if (item.items) {
            var result = processItems(item.items, item.__analytics);

            if (!item.__analytics || selectedUnits.length) {
              // Folder didn't have analytics, so process it
              item.__analytics = result[0];
              accumulateAnalytics(defaultAnalytics, item.__analytics);
              processAccumulatedAnalytics(item.__analytics);
              addMixedCompletion(item.__analytics.itemsCount);
            } else if (item.__analytics && item.__analytics.itemsCount) {
              // Modify the existing analytics
              addMixedCompletion(item.__analytics.itemsCount);
            }
            item.hidden = isHidden(item.__analytics);

            if (!anyActivitiesSelected) {
              // As no activity selection is performed, use default analytics
              item.hiddenInCustomisedView = item.hidden;

              if (flags.transformToP3) {
                if (flags.transformToP3.deleteItems) {
                  delete item.items;
                  delete item.model;
                  delete item.name;
                  delete item['item-type'];
                  delete item['sub-type'];
                }
                extractSelectiveAnalytics(item.__analytics);
              } else {
                item.customisedAnalytics = item.__analytics;
              }

              return;
            }

            item.customisedAnalytics = result[1];
            accumulateAnalytics(customisedAnalytics, item.customisedAnalytics);
            processAccumulatedAnalytics(item.customisedAnalytics);
            addMixedCompletion(item.customisedAnalytics.itemsCount);
            item.hiddenInCustomisedView = isHidden(item.customisedAnalytics);

            if (item.customisedAnalytics.itemsCount.total === 0) {
              // Folders will be hidden in customised view if they contain zero activities
              item.hiddenInCustomisedView = true;
              item.name += '*';
            }

            if (flags.transformToP3) {
              if (flags.transformToP3.deleteItems) {
                delete item.items;
                delete item.model;
                delete item.name;
                delete item['item-type'];
                delete item['sub-type'];
              }
              if (item.customisedAnalytics.itemsCount.total === item.__analytics.itemsCount.total) {
                // As the activity count is same, use default analytics
                delete item.customisedAnalytics;
              } else {
                extractSelectiveAnalytics(item.customisedAnalytics);
              }
              extractSelectiveAnalytics(item.__analytics);
            }

            return;
          }

          if (!_contentHelper.ContentHelper.isContentVisible(item, { includeDownloadables: true })) {
            // Teacher only activities are not required in analytics, so return
            if (tocFolderDepth === 0 && flags.transformToP3 && flags.transformToP3.deleteItems) {
              delete item.__analytics;
            }
            return;
          }

          _this.updateAnalyticsAsPerClassCustomisations(item);

          var hoaxFolderAnalytics = void 0;

          if (tocFolderDepth === 0 && flags.transformToP3) {
            hoaxFolderAnalytics = getFolderLevelAnalyticsObject();
            updateFolderAnalyticsForItem(hoaxFolderAnalytics, item);
            processAccumulatedAnalytics(hoaxFolderAnalytics);
            extractSelectiveAnalytics(hoaxFolderAnalytics);
          }

          var itemVisibility = _contentHelper.ContentHelper.isContentVisible(item, flags.contentFlags);

          item.iconObj = _this.getStatusIconForContent(item);
          item.scoresObj = _this.getFormattedScore(item);
          item.isSubmittableContent = _contentHelper.ContentHelper.isSubmittableContent(item);
          item.hidden = !itemVisibility || hideNonStartedItems && !_this._isTestTypeComp && item.__analytics && item.__analytics.status === 'not_started';

          if (!existingDefaultAnalytics || selectedUnits.length) {
            updateFolderAnalyticsForItem(defaultAnalytics, item);
          }

          if (!anyActivitiesSelected) {

            if (hoaxFolderAnalytics) {
              if (flags.transformToP3.deleteItems) {
                // Removing redundant fields from the item
                deleteAllKeysFromObject(item, ['hidden', 'item-code']);
              }
              item.__analytics = hoaxFolderAnalytics;
            }

            return;
          }

          var activityIncluded = isItemSelected(item['item-code'], gradeSelectedActivities) || !anyActivitiesSelected;

          if (!activityIncluded) {
            item.hiddenInCustomisedView = true;
            item.name += '*';

            if (hoaxFolderAnalytics) {

              if (flags.transformToP3.deleteItems) {
                // Removing redundant fields from the item
                deleteAllKeysFromObject(item, ['item-code', 'hidden', 'hiddenInCustomisedView']);
              }

              item.__analytics = hoaxFolderAnalytics;
              item.customisedAnalytics = getFolderLevelAnalyticsObject();
              processAccumulatedAnalytics(item.customisedAnalytics);
              extractSelectiveAnalytics(item.customisedAnalytics);
            }

            return;
          }

          // As the activity is part of grade calculation, update customised analytics
          updateFolderAnalyticsForItem(customisedAnalytics, item);

          if (hoaxFolderAnalytics) {
            if (flags.transformToP3.deleteItems) {
              // Removing redundant fields from the item
              deleteAllKeysFromObject(item, ['hidden', 'item-code']);
            }
            item.__analytics = hoaxFolderAnalytics;
          }
        });

        addMixedCompletion(defaultAnalytics.itemsCount);
        anyActivitiesSelected && addMixedCompletion(customisedAnalytics.itemsCount);

        return [defaultAnalytics, customisedAnalytics];
      };

      var processed = processItems(productToc.items, productToc.__analytics);

      if (!productToc.__analytics || selectedUnits.length) {
        productToc.__analytics = processed[0];
        processAccumulatedAnalytics(productToc.__analytics);
      }
      productToc.hidden = isHidden(productToc.__analytics, true);

      if (!anyActivitiesSelected) {
        productToc.hiddenInCustomisedView = productToc.hidden || productColumn && productColumn.weightage === '0';

        if (flags.transformToP3) {
          delete productToc.__analytics;
          return productToc;
        }

        // As no activity selection is performed, use default analytics
        productToc.customisedAnalytics = productToc.__analytics;
        return productToc;
      }

      productToc.customisedAnalytics = processed[1];
      processAccumulatedAnalytics(productToc.customisedAnalytics);
      productToc.hiddenInCustomisedView = isHidden(productToc.customisedAnalytics, true) || productColumn.weightage === '0' || productToc.customisedAnalytics.itemsCount.total === 0;

      if (flags.transformToP3) {
        delete productToc.customisedAnalytics;
        delete productToc.__analytics;
      }

      return productToc;
    }
  }]);

  return ProductContentHelper;
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EnTranslations = {
  '__CONTENT_HELPER__': {
    'SCORES': {
      'FIRST_SCORE': 'First score',
      'BEST_SCORE': 'Best score',
      'ATTEMPTS': 'Attempts',
      'VIEWED': 'Viewed',
      'TEACHER_SCORE': 'Teacher score'
    },
    'SCREEN_READER': {
      'STATUS_NOT_STARTED': 'Activity status: Not started',
      'STATUS_IN_PROGRESS': 'Activity status: in progress',
      'STATUS_VIEWED': 'Activity status: viewed',
      'STATUS_EVALUATION_PENDING': 'Activity status: evaluation pending',
      'STATUS_ABOVE_THRESHOLD': 'Activity status: completed above target score',
      'STATUS_BELOW_THRESHOLD': 'Activity status: completed below target score',
      'STATUS_GAIN_REWARD': 'Activity status: incomplete, reward to gain',
      'STATUS_COMPLETED': 'Activity status: completed',
      'TOP_STATUS_IN_PROGRESS': 'Status: in progress',
      'TOP_STATUS_EVALUATION_PENDING': 'Status: evaluation pending',
      'TOP_STATUS_ABOVE_THRESHOLD': 'Status: completed above target',
      'TOP_STATUS_BELOW_THRESHOLD': 'Status: completed below target'
    }
  }
};

module.exports = EnTranslations;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EsTranslations = {
  '__CONTENT_HELPER__': {
    'SCORES': {
      'FIRST_SCORE': 'Primer puntaje',
      'BEST_SCORE': 'Mejor puntaje',
      'ATTEMPTS': 'Intentos',
      'VIEWED': 'Visto',
      'TEACHER_SCORE': 'Puntaje del profesor'
    },
    'SCREEN_READER': {
      'STATUS_NOT_STARTED': 'Condición de actividad: no comenzada',
      'STATUS_IN_PROGRESS': 'Condición de actividad: en desarrollo',
      'STATUS_VIEWED': 'Activity status: viewed',
      'STATUS_EVALUATION_PENDING': 'Condición de actividad: evaluación pendiente',
      'STATUS_ABOVE_THRESHOLD': 'Condición de actividad: completadas con puntaje superior al objetivo',
      'STATUS_BELOW_THRESHOLD': 'Condición de actividad: completadas con puntaje inferior al objetivo',
      'STATUS_GAIN_REWARD': 'Estado de actividad: incompleta, recompensa aún por ganar',
      'STATUS_COMPLETED': 'Activity status: completed',
      'TOP_STATUS_IN_PROGRESS': 'Status: in progress',
      'TOP_STATUS_EVALUATION_PENDING': 'Status: evaluation pending',
      'TOP_STATUS_ABOVE_THRESHOLD': 'Status: completed above target',
      'TOP_STATUS_BELOW_THRESHOLD': 'Status: completed below target'
    }
  }
};

module.exports = EsTranslations;

/***/ })
/******/ ]);
});
